var _polygon, _polyline, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIsometric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    id: "icon-isometric",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "4,9.7 4,23.2 16,30 28,23.2 28,9.7 16,3 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "4,10.2 16,17 28,10.2 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 16,
    y1: 30,
    x2: 16,
    y2: 17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIsometric);
export default __webpack_public_path__ + "static/media/icon-isometric.df2d5fbea2bb1d085a7d316a2bf3ae8d.svg";
export { ForwardRef as ReactComponent };